module.exports = __webpack_public_path__ + "static/media/verizon.53e9f2fb.png";